import React from "react";
import "./skillsNew.css";
import projectsData from "../../data/projectsData";

const Skills = () => {
  const skills = projectsData.allSkills;

  return (
    <section className="skills-section" id="skills">
      <h2 className="section-title">SKILLS</h2>
      <p className="skills-intro">
        Technical skills of Shantanu Basumatary in JavaScript, React, Node.js,
        Python, cloud, and AI/ML tools.
      </p>
      <div className="skills-grid">
        {skills.map((skill) => (
          <div key={skill.id} className="skill-pill">
            <span className="skill-name">{skill.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
